<div class="modal-header">
    <h2 class="modal-title">Pricing Tier</h2>
</div>
<div class="flex-fill d-flex flex-column">
    <div class="card">
        <div class="card-body">
            <dx-form *ngIf="pricingTier" [formData]="pricingTier" validationGroup="mainValidationGroup">
                <dxi-item itemType="group">
                    <dxi-item dataField="name">
                        <dxi-validation-rule type="required"> </dxi-validation-rule>
                    </dxi-item>
                    <dxi-item dataField="percentage" editorType="dxNumberBox" [editorOptions]="{ step: 0 }"> </dxi-item>
                    <dxi-item dataField="minimumAmount" editorType="dxNumberBox" [editorOptions]="{ step: 0, format: { type: 'currency', precision: 2 } }"> </dxi-item>
                    <dxi-item dataField="maximumAmount" editorType="dxNumberBox" [editorOptions]="{ step: 0, format: { type: 'currency', precision: 2 } }"> </dxi-item>
                    <dxi-item dataField="inactive" editorType="dxCheckBox"> </dxi-item>
                    <dxi-item dataField="description"> </dxi-item>
                    <dxi-item dataField="notes"> </dxi-item>
                </dxi-item>
            </dx-form>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button class="btn btn-danger" (click)="save()">Save</button>
    <button class="btn btn-success" (click)="close()">Close</button>
</div>
